import { render, staticRenderFns } from "./AddMonthlyWorkingHours.vue?vue&type=template&id=b445a6c4&"
import script from "./AddMonthlyWorkingHours.vue?vue&type=script&lang=js&"
export * from "./AddMonthlyWorkingHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports